document.addEventListener("DOMContentLoaded", () => {
  const popupOpeners = document.querySelectorAll('.popup-opener');    
  popupOpeners.forEach(popupOpener => popupOpener.addEventListener('click', () => popupOpen(event)));

  const popupCloseButtons = document.querySelectorAll('.popup-close-button');    
  popupCloseButtons.forEach(popupCloseButton => popupCloseButton.addEventListener('click', () => popupClose(event)));

  const popupBackgrounds = document.querySelectorAll('.popup-background'); 
  popupBackgrounds.forEach(popupBackground => popupBackground.addEventListener('click', () => popupClose(event)));

  function popupOpen(event) {
    event.preventDefault();
    let target = event.target || event.srcElement;

    const popupId = target.getAttribute("data-popup-id");
    const popupElement = document.getElementById(`${popupId}`);

    popupElement.setAttribute("open", "");
  }

  function popupClose(event) {
    event.preventDefault();
    let target = event.target || event.srcElement;

    const popupId = target.getAttribute("data-popup-id");
    const popupElement = document.getElementById(`${popupId}`);
    popupElement.removeAttribute("open");
  }

});